import GridStackEdit from '@app/components/common/GridStack/GridStackEdit';
import WidgetCreateOrEditModal from '@app/components/LoggedIn/Home/DashboardCreator/WidgetCreateOrEditModal/WidgetCreateOrEditModal';
import { IWidget, TWidgetTypes } from '@app/state/home/types';
import {
  removeCustomReportElement,
  updateCustomReportComponents,
  updateCustomReportElement,
} from '@app/state/reports/actions';
import { useAppDispatch } from '@app/state/store';
import {
  ICustomReport,
  ICustomReportComponent,
} from '@westondev/tableturn-core';
import { GridStackWidget } from 'gridstack';
import { useState } from 'react';
import { isCustomReportElementInCorrectPage } from '@app/helpers/reports/reports';
import {
  CUSTOM_REPORT_NUMBER_OF_COLUMNS,
  CUSTOM_REPORT_ROW_SIZE,
} from '../CustomReportsCreator/types';

interface ICustomReportsGridStack {
  elements: GridStackWidget[];
}

const CustomReportsGridStack = ({ elements }: ICustomReportsGridStack) => {
  const dispatch = useAppDispatch();
  const enableEdit = true;

  const [modalState, setModalState] = useState<{
    isActive: boolean;
    widgetType: TWidgetTypes | null;
    currentData?: IWidget;
  }>({
    isActive: false,
    widgetType: null,
    currentData: undefined,
  });

  const handleUpdateElements = (updatedElements: ICustomReport['layout']) => {
    const adjustedElements = Object.values(updatedElements).reduce(
      (acc, element) => {
        const { isInCorrectPage, startingRow } =
          isCustomReportElementInCorrectPage(element);
        if (!isInCorrectPage) {
          element.y = startingRow;
        }
        return {
          ...acc,
          [element.id]: element,
        };
      },
      {},
    );
    dispatch(updateCustomReportElement(adjustedElements));
  };

  const handleRemoveElement = (elementId: string) => {
    dispatch(removeCustomReportElement(elementId));
  };

  const handleUpdateWidget = (updatedWidget: IWidget) => {
    if (!modalState.widgetType) return;

    dispatch(
      updateCustomReportComponents(updatedWidget as ICustomReportComponent),
    );
  };

  const handleClickEditWidget = (element: GridStackWidget | null) => {
    if (!element?.content) return;

    const widgetProps = (
      element.content as unknown as {
        props: {
          title: string;
          widgetId: string;
          parameters: Record<string, any>;
          widgetType: TWidgetTypes;
        };
      }
    ).props;

    const widgetData = {
      id: widgetProps.widgetId,
      title: widgetProps.title,
      parameters: widgetProps.parameters,
      type: widgetProps.widgetType,
    };
    setModalState({
      isActive: true,
      widgetType: widgetProps.widgetType,
      currentData: widgetData,
    });
  };

  return (
    <>
      <GridStackEdit
        enableEdit={enableEdit}
        elements={elements}
        onUpdateData={handleUpdateElements}
        onRemoveElement={handleRemoveElement}
        onEditClick={handleClickEditWidget}
        cellHeight={CUSTOM_REPORT_ROW_SIZE}
        columns={CUSTOM_REPORT_NUMBER_OF_COLUMNS}
      />
      <WidgetCreateOrEditModal
        widgetType={modalState.widgetType}
        isActive={modalState.isActive}
        onModalClose={() =>
          setModalState({
            isActive: false,
            widgetType: null,
          })
        }
        onUpdatedWidget={handleUpdateWidget}
        mode="edit"
        currentData={modalState.currentData}
      />
    </>
  );
};

export default CustomReportsGridStack;
